import { __awaiter } from "tslib";
import moment from "moment";
import { ScheduleCitationService } from "@/services/models/schedule/scheduleCitation";
const PAGE_SIZE = 15;
const modulePendingRegistrations = {
    namespaced: true,
    state: {
        appointments: [],
        loading: false,
        currentPage: 1,
        perPage: PAGE_SIZE,
        lastPeriod: null,
        requestId: 0,
        active: false,
    },
    getters: {
        getAppointments(state) {
            const start = (state.currentPage - 1) * state.perPage;
            return state.appointments.slice(start, start + state.perPage);
        },
        getTotal(state) {
            return state.appointments.length;
        },
        getCurrentPage(state) {
            return state.currentPage;
        },
        getPerPage(state) {
            return state.perPage;
        },
        getLoading(state) {
            return state.loading;
        },
        getActive(state) {
            return state.active;
        },
    },
    mutations: {
        setAppointments(state, appointments) {
            state.appointments = appointments;
            state.currentPage = 1;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setCurrentPage(state, page) {
            const pageCount = Math.max(1, Math.ceil(state.appointments.length / state.perPage));
            state.currentPage = Math.min(Math.max(page, 1), pageCount);
        },
        setLastPeriod(state, period) {
            state.lastPeriod = period;
        },
        setRequestId(state, requestId) {
            state.requestId = requestId;
        },
        setActive(state, active) {
            state.active = active;
        },
    },
    actions: {
        loadMonth({ commit, state }, period) {
            return __awaiter(this, void 0, void 0, function* () {
                const requestId = state.requestId + 1;
                commit("setRequestId", requestId);
                commit("setLoading", true);
                const appointments = [];
                // Inicio del mes seleccionado
                const startDate = moment([period.year, period.month - 1, 1]).startOf("month");
                // Validar si el período que se está consultando es el mes actual
                const now = moment();
                const isCurrentMonth = period.month === now.month() + 1 && period.year === now.year();
                // Si es el mes actual, termina ayer. Si es un mes pasado, toma todo el mes completo.
                const endDate = isCurrentMonth ? moment().subtract(1, "days") : startDate.clone().endOf("month");
                try {
                    const filter = {
                        unique_professional_id: period.professionalId,
                        state: "agendado",
                        start_date: startDate.format("YYYY-MM-DD"),
                        end_date: endDate.format("YYYY-MM-DD"),
                        name: null,
                        show_group: false,
                        excluded_consultation_type: localStorage.getItem("role_id") == "4" ? true : null,
                    };
                    const firstPage = (yield ScheduleCitationService.getByProfessional(filter, 1));
                    appointments.push(...(firstPage.data || []));
                    const appointmentIds = new Set(appointments.map((appointment) => appointment.id));
                    const perPage = firstPage.per_page || PAGE_SIZE;
                    const total = firstPage.total || appointments.length;
                    const pageCount = Math.ceil(total / perPage);
                    for (let page = 2; page <= pageCount; page += 1) {
                        const response = (yield ScheduleCitationService.getByProfessional(filter, page));
                        const pageAppointments = response.data || [];
                        const newAppointments = pageAppointments.filter((appointment) => !appointmentIds.has(appointment.id));
                        if (newAppointments.length === 0)
                            break;
                        newAppointments.forEach((appointment) => appointmentIds.add(appointment.id));
                        appointments.push(...newAppointments);
                    }
                    if (requestId !== state.requestId)
                        return;
                    appointments.sort((left, right) => {
                        var _a, _b, _c, _d, _e, _f;
                        const leftAt = `${((_b = (_a = left.schedule_detail) === null || _a === void 0 ? void 0 : _a.day_selected) === null || _b === void 0 ? void 0 : _b.date) || ""} ${((_c = left.schedule_detail) === null || _c === void 0 ? void 0 : _c.time_start) || ""}`;
                        const rightAt = `${((_e = (_d = right.schedule_detail) === null || _d === void 0 ? void 0 : _d.day_selected) === null || _e === void 0 ? void 0 : _e.date) || ""} ${((_f = right.schedule_detail) === null || _f === void 0 ? void 0 : _f.time_start) || ""}`;
                        return leftAt.localeCompare(rightAt);
                    });
                    commit("setAppointments", appointments);
                    commit("setLastPeriod", Object.assign({}, period));
                }
                catch (error) {
                    if (requestId === state.requestId) {
                        throw error;
                    }
                }
                finally {
                    if (requestId === state.requestId) {
                        commit("setLoading", false);
                    }
                }
            });
        },
        setPage({ commit }, page) {
            commit("setCurrentPage", page);
        },
        reload({ dispatch, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const period = state.lastPeriod;
                if (period) {
                    yield dispatch("loadMonth", period);
                }
            });
        },
    },
};
export default modulePendingRegistrations;
